<template>
    <div>
        <div style="color:darkred" v-if="chartData.orphans.length>1">
          <span><strong>Orphan fields</strong> (fields that are referenced by this column but they do not exist):</span>
          <ul>
            <li v-for="orphan in chartData.orphans">{{orphan}}</li>
          </ul>
        </div>
      <div style="margin-bottom:30px;">
        <!--
        <el-slider v-model="x_strength_raw" :min="0" :max="20" :step="1"></el-slider>
        <el-slider v-model="y_strength_raw" :min="0" :max="20" :step="1"></el-slider>
        -->
        Size
        <el-slider v-model="rect_size_factor" :min="0.1" :max="2" :step="0.1"></el-slider>
        Space
        <el-slider v-model="collide_raw" :min="0" :max="200" :step="1"></el-slider>
      </div>
        <div class="timeline_network" ref="d3_root"></div>
    </div>
</template>

<script>
    import * as d3 from "d3";
    export default {
        data() {
            return {
                x_strength_raw: 15,
                y_strength_raw: 5,
                collide_raw: 20,
                rect_size_factor: 1,
            }
        },
        mounted() {
            if (this.chartData) {
                this.draw()
            }
        },
        computed: {
            rect_width: function () {
                return 200 * this.rect_size_factor
            },
            rect_height: function () {
              return 100 * this.rect_size_factor
            },
        },
        watch: {
            rect_size_factor: function (newValue) {
              if (newValue) this.draw()
            },
            x_strength_raw: function (newValue) {
              if (newValue) this.draw()
            },
            y_strength_raw: function (newValue) {
              if (newValue) this.draw()
            },
            collide_raw: function (newValue) {
              if (newValue) this.draw()
            },
            highlighted: function (newValue,oldValue) {
              if (newValue !== oldValue) this.draw()
            },
            chartData: function (newValue) {
                if (newValue) this.draw()
            },
            height: function(newValue) {
                if (newValue) this.draw()
            },
            text_size: function(newValue) {
                if (newValue) this.draw()
            },
            hover_category: function(newValue) {
                this.draw()
            }
        },
        props: ['height','width', 'text_size', 'chartData','highlighted'],
        methods: {

            draw() {
              const format = d3.format(",d")

              const svg_element = document.createElementNS("http://www.w3.org/2000/svg",'svg')

              let text_height_in_px = 5 + (this.text_size / 100) * 15 // Want values between 5 and 20

              while (this.$refs.d3_root.firstChild) {
                this.$refs.d3_root.removeChild(this.$refs.d3_root.firstChild);
              }

              const svg = d3.select(this.$refs.d3_root).append('svg')
                  .style("font", text_height_in_px + "px sans-serif")
                  .attr("width", this.width)
                  .attr("height",this.height)
              ;
              d3.select(svg_element)
                  .append('g')
              ;

              var x_mult = 300,
                  y_mult = 160;

              let rect_width = this.rect_width
              let rect_height = this.rect_height

              let svgContainer = svg.append('g');

              function goodDirection(source, target) {
                return (target.slot_x > source.slot_x) || ((target.slot_x === source.slot_x) && (target.field_order>source.field_order))
              }

              function position(source,target)
              {
                let coords = {
                  x1: source.x,
                  y1: source.y,
                  x2: target.x,
                  y2: target.y
                }
                if (goodDirection(source,target)) {
                  if (source.slot_x===target.slot_x) {
                    coords.y1 = coords.y1 + rect_height/2
                    coords.y2 = coords.y2 - rect_height/2 - 4
                  } else {
                    coords.x1 = coords.x1 + rect_width/2
                    coords.x2 = coords.x2 - rect_width/2 - 4
                    coords.y2 = coords.y2 + (source.slot_y) * 10 - 10
                  }
                }
                return coords
              }

              function ticked() {
                svgContainer.selectAll('.link')
                    .attr("x1", function(d) { return position(d.source,d.target).x1 })
                    .attr("y1", function(d) { return position(d.source,d.target).y1 })
                    .attr("x2", function(d) { return position(d.source,d.target).x2})
                    .attr("y2", function(d) { return position(d.source,d.target).y2});


                svgContainer.selectAll('.node')
                    .attr("transform", function(d) {
                      return "translate(" + d.x + "," + d.y + ")"
                    });
              }

              var simulation = d3.forceSimulation(this.chartData.nodes,)
                  .velocityDecay(0.55)
                  .force('charge', d3.forceManyBody().strength(-100).distanceMin(10000))
                  .force("xPosition", d3.forceX(function(d){ return 100 + d.slot_x * x_mult}).strength(this.x_strength_raw/10))
                  .force("yPosition", d3.forceY(function(d){ return 100 + d.slot_y*y_mult}).strength(this.y_strength_raw/10))
                  .force('collide', d3.forceCollide(this.collide_raw))
                  .force('link', d3.forceLink(this.chartData.links)
                      .id((d) => { return d.id; })
                      .distance(400)
                      .strength(0.1)
                  )
                  .force('y', d3.forceY(this.height / 2))
                  .force('x', d3.forceX(this.width / 2))
                  .on('tick', ticked);

              svg.append("marker")
                  .attr("id","arrow")
                  .attr("viewBox","0 -5 10 10")
                  .attr("refX",5)
                  .attr("refY",0)
                  .attr("markerWidth",10)
                  .attr("markerHeight",10)
                  .attr("orient","auto")
                  .append("path")
                  .attr("d", "M0,-5L10,0L0,5");

              svg.append("marker")
                  .attr("id","arrow-bad")
                  .attr("viewBox","0 -5 10 10")
                  .attr("refX",5)
                  .attr("refY",0)
                  .attr("markerWidth",10)
                  .attr("markerHeight",10)
                  .attr("orient","auto")
                  .append("path")
                  .attr('fill','red')
                  .attr('stroke','none')
                  .attr("d", "M0,-5L10,0L0,5");

              svg.append("marker")
                  .attr("id","dot")
                  .attr("viewBox","0 0 10 10")
                  .attr("refX",5)
                  .attr("refY",5)
                  .attr("markerWidth",5)
                  .attr("markerHeight",5)
                  .attr("orient","auto")
                  .append('circle')
                  .attr('cx',5)
                  .attr('cy',5)
                  .attr('r',5)
                  .attr('stroke','none')
                  .attr('fill','red');

              this.chartData.slots.forEach((slot) => {
                svgContainer.append('text')
                    .text(function (d) { return slot.type })
                    .style("text-anchor", "middle")
                    .attr("x", function(d) { return 100 + slot.slot_x * x_mult })
                    .attr("y",15)
                svgContainer.append('text')
                    .text(function (d) { return slot.started })
                    .style("text-anchor", "middle")
                    .attr("x", function(d) { return 100 + slot.slot_x * x_mult })
                    .attr("y",40)
              } )

              const linkUpdate = svgContainer.selectAll('.link').data(
                  this.chartData.links,
                  (d) => { return `${d.source.id}-${d.target.id}`; }
              );

              linkUpdate.enter()
                  .append('line')
                  .attr('class', 'link')
                  .attr('marker-end', (d) => {return goodDirection(d.source,d.target) ? 'url(#arrow)' : 'url(#arrow-bad)'})
                  .attr('marker-start','url(#dot)')
                  .style('stroke', (d) => {
                    return goodDirection(d.source,d.target) ? 'black' : 'red';
                  })
                  .style('stroke-width', (d) => {
                    return goodDirection(d.source,d.target)  ? 1 : 5;
                  })

              ;

              linkUpdate.exit()
                  .remove();

              const nodeUpdate = svgContainer.selectAll('.node').data(
                  this.chartData.nodes,
                  (d) => { return d.id; }
              )

              let g = nodeUpdate.enter()
                  .append('g')
                  .attr('class', 'node')

              g
                  .append('rect')

                  .attr("x", (d) => { return -rect_width/2; })
                  .attr("y", (d) => { return -rect_height/2; })

                  .attr('width', (d) => { return rect_width })
                  .attr('height', (d) => { return rect_height })
                  .attr('stroke','black')
                  .attr('stroke-dasharray',(d) => { return d.shadow ? "" : '5,5'})
                  .attr("fill-opacity",(d) => { return d.shadow ? 0.95 : 0.55})
                  .style('fill', (d) => {
                    if (d.highlight==='error') return '#F46366';
                    else if (d.highlight==='highlight') return 'yellow';
                    else return '#eeeeee';
                  })
                  .on('click', () => {
                    if (dataSourceIndex < DATA.length - 1) {
                      dataSourceIndex++;
                      pushData()
                      updateGraph(svgContainer);
                    }
                  })
                  .exit()

              g.append('text')
                  .text(function (d) { return d.name; })
                  .attr('font-weight','bold')
                  .style("text-anchor", "middle")
                  .attr("y", function(d) { return -20; });

              g.append('text')
                  .text(function (d) { return d.column_type; })
                  .style("text-anchor", "middle")
                  .attr("y", function(d) { return 20; })

              nodeUpdate.exit()
                  .remove();

              simulation.nodes(this.chartData.nodes);
              simulation.force('link').links(this.chartData.links);
              simulation.alpha(1).restart();

            },
            removeElement(elementId) {
                // Removes an element from the document
                var element = document.getElementById(elementId);
                element.parentNode.removeChild(element);
            },
        }
    }
</script>